import { JWPlayer } from '../types/video';

export const setCaptionsConfig = (player: JWPlayer) => {
  if (!player) return;

  player.setCurrentCaptions(0); // JW injects `off` as first track, so this will turn off captions by default
  player.setCaptions({
    color: '#ffffff',
    backgroundColor: '#000000',
    backgroundOpacity: 50,
    edgeStyle: 'dropshadow',
    fontSize: 14,
    windowColor: '#000000',
    windowOpacity: 75,
  });
};
